export default __webpack_public_path__ + "static/media/ally_m2.3c4ae8fe.png";